// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"497":"c4a970ea462c57df","886":"a2798116586f0a83"}[chunkId] + ".js";
};